export const ACQUISITION_FEE_ID = 1050;
export const PAYMENT_FAILURE_TIMEOUT = 7000;
export const MINIMUM_CASH_DOWN_THRESHOLD = 0.01;

export const PAYMENT_REQUEST_OVERRIDE_NODE = 'paymentRequestOverride';

export const GRID_TYPED_OVERRIDES = 'gridTyped' as const;

export type DropOverrides = boolean | typeof GRID_TYPED_OVERRIDES;

export const TermTypeWithExtension = {
    TERM: 'term',
    ANNUALMILES: 'annualmiles',
    DOWNPAYMENT: 'downpayment',
    FORDFLEXBUY: 'fordflexbuy'
};

export const ValidatePreferredTerm = {
    TERM: 'months',
    DOWNPAYMENT: 'requestedDownPayment',
    FORDFLEXBUY: 'initialPaymentDiscount'
};

export const FeesCategoriesType = {
    DEALER: 'Dealer',
    LENDER: 'Lender',
    GOVERNMENT: 'Government'
};

export const DEFAULT_RATE_TYPE_MAPPING = {
    finance: 'APR',
    lease: 'MoneyFactor',
    balloon: 'APR'
} as const;

export const RATE_TYPE = {
    APR: 'APR',
    MoneyFactor: 'MoneyFactor',
    InterestRate: 'InterestRate'
} as const;

export const MAX_MONEY_FACTOR = 0.0208;

/**
 * DE785177: the rebate ledger total (`manualIncentives.totalRebates`) a grid row request was built from, stamped
 * on its PAYMENT_RECEIVED. The reducer compares it with the ledger when the reply lands: a different total means
 * the ledger changed while the request was in flight, so the reply was priced on a rebate the deal no longer holds.
 */
export const REQUEST_LEDGER_REBATES_META = 'requestLedgerRebates';
